import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideAlerter = (ref: any, setState: Function) => {
  useEffect(() => {
    function handleClickOutside(event: any) {
      // Overlays that portal into <body> (e.g. the image cropper) sit visually
      // on top of this element but outside its DOM subtree — clicking them must
      // not close whatever opened them.
      if (event.target?.closest?.("[data-overlay-root]")) return;
      if (ref.current && !ref.current.contains(event.target)) {
        setState(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setState]);
};

/**
 * Component that alerts if you click outside of it
 */
const OutsideAlerter = ({
  setState,
  children,
}: {
  children: any;
  setState: Function;
}) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setState);

  return <div ref={wrapperRef}>{children}</div>;
};

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};

export default OutsideAlerter;
